import React, { useCallback, useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { pushNotification } from "utils/notifications";
import CongNoBanHangApi from "service/QuanLyMuaBan/CongNoBanHangApi";
import DateTimePicker from "components/GenericComponent/DateTimePicker";
import NumberFormat from "react-number-format";
import { formatDateV2 } from "utils/formatDate";

const ModalThanhToan = ({ orderId, onClose }) => {
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [dataHasChanged, setDataHasChanged] = useState(false);
  const [TienConNo, setTienConNo] = useState(0);
  const [NgayThanhToan, setNgayThanhToan] = useState(new Date());
  const [TienThanhToan, setTienThanhToan] = useState(0);
  const [GhiChu, setGhiChu] = useState("");
  const [hinhThucThanhToan, setHinhThucThanhToan] = useState(0);
  const loadData = useCallback(() => {
    if (!orderId) return;
    setLoading(true);

    CongNoBanHangApi.getThongTinThanhToan(orderId)
      .then((res) => {
        if (res.status === 200 && res.data) {
          setTienConNo(res.data.ConNo || 0);
          setTienThanhToan(res.data.ConNo || 0);
        } else {
          pushNotification("Lỗi tải thông tin thanh toán", "error");
          onClose(false);
        }
      })
      .catch((err) => {
        console.error("Lỗi load thông tin thanh toán:", err);
        pushNotification("Lỗi tải dữ liệu", "error");
        onClose(false);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  useEffect(() => {
    loadData();
  }, []);

  const handleSave = () => {
    if (TienThanhToan <= 0) {
      pushNotification("Vui lòng nhập số tiền thanh toán", "error");
      return;
    }
    if (TienThanhToan > TienConNo) {
      pushNotification(
        "Số tiền thanh toán không thể lớn hơn số tiền còn nợ",
        "error"
      );
      return;
    }
    setSaving(true);
    const payload = {
      OrderID: orderId,
      NgayThanhToan: formatDateV2(NgayThanhToan),
      TienThanhToan: TienThanhToan,
      GhiChu: GhiChu,
      HinhThucThanhToan: hinhThucThanhToan,
    };
    CongNoBanHangApi.luuThanhToan(payload)
      .then((res) => {
        if (res.status === 200) {
          pushNotification(res.data || "Lưu thành công", "success");
          setDataHasChanged(true);
          onClose(true);
        } else {
          pushNotification(res.message || "Lưu thất bại", "error");
        }
      })
      .catch((err) => {
        console.error("Lỗi lưu thanh toán:", err);
        const errMsg =
          err.response?.data?.Message || err.message || "Lỗi máy chủ";
        pushNotification(errMsg, "error");
      })
      .finally(() => {
        setSaving(false);
      });
  };

  return (
    <Modal
      show={true}
      onHide={() => onClose(dataHasChanged)}
      centered
      className="modal-new modal fade text-left"
      backdrop="static"
      keyboard={false}
      animation={true}
      style={{ zIndex: 1050 }}
    >
      <Modal.Header>
        <h2
          className="modal-title color7-bold"
          style={{ padding: "7px 14px 7px 14px" }}
        >
          Thanh toán
        </h2>
        <button
          type="button"
          className="close-popup-new"
          onClick={() => onClose(dataHasChanged)}
          disabled={saving}
        >
          <i className="mdi mdi-close"></i>
        </button>
      </Modal.Header>
      <Modal.Body>
        {loading && <div className="loader loader-default is-active"></div>}

        <div className="row">
          <div className="col-md-12">
            <div className="form-group">
              <label>Tiền còn nợ</label>
              <NumberFormat
                className="form-control"
                value={TienConNo}
                thousandSeparator=","
                displayType="input"
                disabled
                style={{ fontWeight: "bold", color: "red" }}
              />
            </div>
          </div>
          <div className="col-md-12">
            <div className="form-group">
              <label>Ngày thanh toán</label>
              <DateTimePicker
                id="NgayThanhToan"
                value={NgayThanhToan}
                onChange={setNgayThanhToan}
                className="form-control input-sm"
              />
            </div>
          </div>
          <div className="col-md-12">
            <div className="form-group">
              <label>
                Tiền thanh toán <span className="text-danger">(*)</span>
              </label>
              <NumberFormat
                className="form-control"
                placeholder="Nhập số tiền"
                value={TienThanhToan}
                thousandSeparator=","
                onValueChange={(values) =>
                  setTienThanhToan(values.floatValue || 0)
                }
                allowNegative={false}
              />
            </div>
          </div>
          <div className="col-md-12">
            <div className="form-group">
              <label>
                Hình thức thanh toán <span className="text-danger">(*)</span>
              </label>
              <select
                name="BeforeAfter"
                className="form-control input-sm select-v2"
                onChange={(e) => setHinhThucThanhToan(e.target.value)}
                value={hinhThucThanhToan}
              >
                <option value="0">Tiền mặt</option>
                <option value="1">Chuyển khoản</option>
              </select>
            </div>
          </div>
          <div className="col-md-12">
            <div className="form-group">
              <label>Ghi chú</label>
              <textarea
                className="form-control1 input-sm"
                placeholder="Nhập nội dung ghi chú"
                value={GhiChu}
                onChange={(e) => setGhiChu(e.target.value)}
                rows={3}
                style={{ width: "100%" }}
              ></textarea>
            </div>
          </div>
        </div>
      </Modal.Body>

      <Modal.Footer>
        <button
          className="btn btn-new-main btn-closenew"
          onClick={() => onClose(dataHasChanged)}
          disabled={saving}
        >
          <i className="mdi mdi-close"></i>&nbsp; Đóng
        </button>
        <button
          className="btn btn-checknew"
          disabled={saving || loading}
          style={{
            background: "#056569",
            color: "white",
            borderRadius: "6px",
            fontSize: "15px",
            textTransform: "none",
          }}
          onClick={handleSave}
        >
          {saving ? (
            <>
              <span className="spinner-border spinner-border-sm"></span>&nbsp;
              Đang lưu...
            </>
          ) : (
            <>
              <i className="mdi mdi-check"></i>&nbsp; Thanh toán
            </>
          )}
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalThanhToan;
